export const SELLER_PROFILE_REQUEST = 'SELLER_PROFILE_REQUEST'
export const SELLER_PROFILE_SUCCESS = 'SELLER_PROFILE_SUCCESS'
export const SELLER_PROFILE_FAIL = 'SELLER_PROFILE_FAIL'

export const SELLER_LISTINGS_REQUEST = 'SELLER_LISTINGS_REQUEST'
export const SELLER_LISTINGS_SUCCESS = 'SELLER_LISTINGS_SUCCESS'
export const SELLER_LISTINGS_FAIL = 'SELLER_LISTINGS_FAIL'

export const SELLER_RATE_REQUEST = 'SELLER_RATE_REQUEST'
export const SELLER_RATE_SUCCESS = 'SELLER_RATE_SUCCESS'
export const SELLER_RATE_FAIL = 'SELLER_RATE_FAIL'
export const SELLER_RATE_RESET = 'SELLER_RATE_RESET'
